import React from "react";

import { animated } from "@react-spring/web";

import { Progress, Result } from "./components";
import { CarProps } from "./types";
import { useCar } from "./hooks";

export const Car = (props: CarProps) => {
  const { getCarProps } = useCar(props);
  return (
    <animated.div {...getCarProps()}>
      <Result car={props.car} />
      <Progress car={props.car} />
    </animated.div>
  );
};
